import { PercentPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'percentage',
	pure: true,
})
export class PercentagePipe implements PipeTransform {
	private readonly percentPipe = inject(PercentPipe);
	private readonly translate = inject(TranslateService);

	language: string;

	constructor() {
		/* v8 ignore start */
		this.language =
			this.translate.getCurrentLang() ?? this.translate.getFallbackLang();
		/* v8 ignore stop */
	}

	transform(percentage: number): string | null {
		return this.percentPipe.transform(
			percentage / 100,
			undefined,
			this.language,
		);
	}
}
